/**
 *
 * @param {import('@apollo/client').ApolloClient<object>} graphql - Apollo client
 * @param {object} param - parameters
 * @param {object} param.variables - graphql variables
 * @param {import('graphql').DocumentNode} param.query - graphql query
 * @returns {Promise<*>} - graphql response
 */
const queryClientSideGraphQL = async (graphql, { query, variables }) => {
  try {
    const { data } = await graphql.query({
      query,
      variables,
    });
    return data;
  } catch (error) {
    throw new Error(error);
  }
};

/**
 *
 * @param {import('@apollo/client').ApolloClient<object>} graphql - Apollo client
 * @param {object} param - parameters
 * @param {object} param.variables - graphql variables
 * @param {import('graphql').DocumentNode} param.mutation - graphql mutation
 * @returns {Promise<*>} - graphql response
 */
const mutateClientSideGraphQL = async (graphql, { variables, mutation }) => {
  try {
    const { data } = await graphql.mutate({
      mutation,
      variables,
    });
    return data;
  } catch (error) {
    throw new Error(error);
  }
};

export { queryClientSideGraphQL, mutateClientSideGraphQL };
